import { attendance } from '@/pages/Attendance/Attendance.i18n.en'
import { config } from '@/pages/ConfigTimeWork/Config.i18n.en'

import { admins } from './Admin/Admin.i18n.en'
import { announcements } from './Announcements/Announcements.i18n.en'
import { attendanceEmployee } from './AttendanceEmployee/AttendanceEmployee.i18n.en'
import { attendanceLogs } from './AttendanceLogs/AttendanceLogs.i18n.en'
import { customers } from './Customer/Customers.i18n.en'
import { detergentHistories } from './DetergentHistories/DetergentHistories.i18n.en'
import { detergents } from './Detergents/Detergents.i18n.en'
import { employees } from './Employees/Employees.i18n.en'
import { idCards } from './IdCards/IdCards.i18n.en'
import { languages } from './Languages/Languages.i18n.en'
import { login } from './Login/Login.i18n.en'
import { machines } from './Machine/Machines.i18n.en'
import { machineParts } from './MachineParts/MachineParts.i18n.en'
import { operators } from './Operators/Operators.i18n.en'
import { tanks } from './Tank/Tank.i18n.en'
import { tankHistories } from './TankHistory/TankHistories.i18n.en'
import { terminals } from './Terminals/Terminals.i18n.en'
import { uniforms } from './Uniforms/Uniforms.i18n.en'
import { washingCount } from './WashingCount/WashingCount.i18n.en'
import { washingHistory } from './WashingHistory/WashingHistory.i18n.en'
import { washingMachinePart } from './WashingMachinePart/WashingMachinePart.i18n.en'
import { washingMethods } from './WashMethods/WashingMethods.i18n.en'
export const pages = {
  announcements,
  employees,
  idCards,
  languages,
  terminals,
  uniforms,
  attendanceLogs,
  login,
  admins,
  attendanceEmployee,
  attendance,
  config,
  customers,
  operators,
  machines,
  machineParts,
  detergents,
  detergentHistories,
  washingMethods,
  washingCount,
  washingMachinePart,
  tanks,
  tankHistories,
  washingHistory,
}
